import { render } from "./WorkGame.vue?vue&type=template&id=db277ab2&scoped=true"
import script from "./WorkGame.vue?vue&type=script&lang=js"
export * from "./WorkGame.vue?vue&type=script&lang=js"

import "./WorkGame.vue?vue&type=style&index=0&id=db277ab2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db277ab2"]])

export default __exports__